function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
import { serializePath } from '../utils/paperjs';
export class EllipseTool extends WhiteboardTool {
  constructor(enableToolEvent, modelGetter, shadowEmitter, scope) {
    super(enableToolEvent, modelGetter, shadowEmitter, scope);
    _defineProperty(this, "elementModel", null);
    _defineProperty(this, "from", null);
    _defineProperty(this, "to", null);
    _defineProperty(this, "showLiveCursor", true);
    this.tool.minDistance = 1;
  }
  onMouseDown(event) {
    if (this.elementModel) {
      this.elementModel.dispose();
    }
    this.elementModel = null;
    this.modelGetter().then(model => {
      if (model) {
        this.elementModel = model.createSegmentedPath('ellipse', true);
      }
    });
    this.from = event.point.clone();
    this.to = event.point.clone();
  }
  onMouseDrag(event) {
    if (this.from && this.elementModel) {
      this.to = event.point.clone();
      const rect = new this.scope.Rectangle(this.from, this.to);
      const pathRect = new this.scope.Path.Ellipse(rect);
      const points = serializePath(pathRect);
      this.elementModel.setPoints(points);
    }
  }
  onMouseUp(event) {
    if (this.elementModel && this.from && this.from.getDistance(event.point) < 3) {
      this.modelGetter().then(model => {
        if (model && this.elementModel) {
          model.removeElementItem(this.elementModel.uuid);
        }
      });
    } else {
      if (this.elementModel) {
        this.elementModel.shadow = '';
      }
    }
  }
}